import { getClient } from '@api/client';
import { graphql } from '@api/generated';

export const getOutboundCallerIdQuery = graphql(`
  query outboundCallerId($id: ID!, $num: String!) {
    outboundCallerId(id: $id, calleeNumber: $num)
  }
`);

export const getOutboundCallerId = async (
  tenantId: string,
  phoneNumber: string,
) => {
  const { data, error } = await getClient().query({
    query: getOutboundCallerIdQuery,
    variables: { id: tenantId, num: phoneNumber },
    fetchPolicy: 'network-only',
  });

  if (error) {
    throw new Error(error.message);
  }

  return data?.outboundCallerId;
};
